import { useState } from 'react';
import { useSafeLayoutEffect } from '../useSafeLayoutEffect/useSafeLayoutEffect';
import { isInDateRange } from './isInDateRange';

export const useIsInDateRange = (
  startDate: Date | string | null,
  endDate: Date | string | null
) => {
  const [isActive, setIsActive] = useState(() =>
    isInDateRange(startDate, endDate)
  );
  useSafeLayoutEffect(() => {
    const updateIsActive = () => {
      setIsActive(isInDateRange(startDate, endDate));
    };

    updateIsActive();

    const interval = setInterval(updateIsActive, 1000);

    return () => clearInterval(interval);
  });
  return isActive;
};
